<script>
import { equals, pluck } from 'rambda'
import { indexByProp, mergeIndex, pluckFlat, pluckId } from '@utils/collections'
import BucketNavigation from './BucketNavigation'
import { actions } from '@utils'
import buildLaptopBuckets from './buildLaptopBuckets'

export default {
  components: {
    BucketNavigation,
  },
  data() {
    return {
      bucketResizeStep: 3,
      laptopBuckets: [],
    }
  },
  computed: {
    articleLaptopBuckets() {
      const articleLaptopByLaptopId = indexByProp(
        'laptopId',
        this.articleLaptops,
      )

      return this
        .laptopBuckets
        .map(({ total, label, laptops }) => ({
          total,
          label,
          laptops: laptops.map(laptop => ({
            articleLaptop: articleLaptopByLaptopId[laptop.id],
            laptop,
          })),
        }))
    },
    bucketsPrices() {
      return pluck('price', this.criteria.buckets)
    },
    isBucketView() {
      return Object
        .keys(this.sortActive)
        .includes('bucketIndex')
    },
  },
  methods: {
    buildLaptopBuckets,
    setBuckets(criteria) {
      this.$up('criteria.buckets', criteria)
    },
    offsetBucketLimit(offset, index) {
      const limitCurrent = this.criteria.buckets[index].limit || 0
      const limitExpected = limitCurrent + offset
      const limit = Math.min(
        Math.max(limitExpected, this.bucketResizeStep),
        this.laptopBuckets[index].total,
      )

      this.setBuckets(mergeIndex(
        index,
        { limit },
        this.criteria.buckets,
      ))
    },
    setBucketsPrices(bucketsPrices) {
      const [bucketFirst] = this.criteria.buckets

      this.setBuckets(
        bucketsPrices
          .map((price, index) => ({
            ...this.criteria.buckets[index] || bucketFirst,
            price,
            limit: this.bucketResizeStep,
          })),
      )
    },
    ...actions('FETCH_MISSING_FILE'),
  },
  watch: {
    laptopBuckets: {
      immediate: true,
      async handler(laptopBuckets) {
        const laptops = pluckFlat('laptops', laptopBuckets)
        const fileIds = pluckId('imageFileId', laptops)

        await this.FETCH_MISSING_FILE(fileIds)
      },
    },
    laptopIdsSelected: {
      immediate: true,
      handler(laptopIdsSelected, laptopIdsSelectedPrevious) {
        if (equals(laptopIdsSelected, laptopIdsSelectedPrevious)) return

        this.buildLaptopBuckets()
      },
    },
    laptopEvaluationsSorted: 'buildLaptopBuckets',
  },
  render: () => '',
}
</script>
